import queryString from "query-string";

function queryStringParams() {
  return queryString.parse(window.location.search);
}

function inEmbedMode() {
  const embedMode = queryStringParams().embed === "true";

  return embedMode;
}

export { queryStringParams, inEmbedMode };
